export class JobData {
  id: number;
  jobPostion: string;
  department: string;
  location: string;
  description: string;
  skills: string;
  searchBytitleSkillPosition: string;
}
